import { useEffect, useState } from 'react';
import AdminService from '../../services/AdminService';
import User from '../../types/User';

export default function useAdminUsers() {
    const [loading, setLoading] = useState<boolean>(true);
    const [updating, setUpdating] = useState<boolean>(false);
    const [users, setUsers] = useState<User[] | undefined>(undefined);
    const [error, setError] = useState<string | null>(null);

    const load = async () => {
        try {
            const result = await AdminService.getUsers();
            setUsers(result);
        } catch (err: any) {
            console.error(err);
            setError(err);
        }
    };

    const refresh = () => {
        const update = async () => {
            setUpdating(true);
            await load();
            setUpdating(false);
        };
        update();
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await load();
            setLoading(false);
        };

        if (!users) {
            init();
        } else {
            refresh();
        }
    }, []);

    return { users, error, loading, refresh, updating };
}
